const API_URL = import.meta.env.VITE_API_URL || '/persona-api';

function getToken(): string | null {
  return localStorage.getItem('auth_token');
}

async function request(method: string, path: string, body?: unknown, auth = true): Promise<Response> {
  const headers: Record<string, string> = { 'Content-Type': 'application/json' };
  if (auth) {
    const token = getToken();
    if (token) headers['Authorization'] = `Bearer ${token}`;
  }
  return fetch(`${API_URL}${path}`, {
    method,
    headers,
    body: body !== undefined ? JSON.stringify(body) : undefined
  });
}

export async function apiGet<T>(path: string, auth = true): Promise<T> {
  const res = await request('GET', path, undefined, auth);
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Erreur réseau' }));
    throw Object.assign(new Error(err.error || 'Erreur'), err);
  }
  return res.json();
}

export async function apiPost<T>(path: string, body: unknown, auth = true): Promise<T> {
  const res = await request('POST', path, body, auth);
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Erreur réseau' }));
    throw Object.assign(new Error(err.error || 'Erreur'), err);
  }
  return res.json();
}

export async function apiDelete<T>(path: string, auth = true): Promise<T> {
  const res = await request('DELETE', path, undefined, auth);
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: 'Erreur réseau' }));
    throw Object.assign(new Error(err.error || 'Erreur'), err);
  }
  return res.json();
}

export async function apiUploadImage(blob: Blob): Promise<string> {
  const token = getToken();
  const formData = new FormData();
  formData.append('image', blob, 'image.jpg');
  const res = await fetch(`${API_URL}/api/uploads/image`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: formData
  });
  if (!res.ok) throw new Error('Erreur upload image');
  const data = await res.json();
  return data.url;
}

export { API_URL };
